// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"386":"admin-fr-i18n","445":"locale-streaming-streaming-fr-i18n","638":"locale-admin-admin-fr-i18n","880":"streaming-fr-i18n"}[chunkId] + "." + {"386":"0f2739fe","445":"fd0d3020","638":"105c6411","880":"a34f9dcd"}[chunkId] + ".js";
};